import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavShare = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon=Send, Style=Bold",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M30.2663 1.7325C29.9521 1.41823 29.5599 1.19337 29.1299 1.0811C28.6999 0.96883 28.2478 0.973197 27.8201 1.09375L27.7926 1.1025L3.80382 8.375C3.31657 8.51628 2.88383 8.80245 2.56308 9.1955C2.24233 9.58856 2.04875 10.0699 2.00806 10.5756C1.96736 11.0813 2.08148 11.5874 2.33525 12.0267C2.58902 12.4659 2.97043 12.8176 3.42882 13.035L13.9688 18.035L18.9688 28.575C19.1684 29.0031 19.4863 29.3653 19.885 29.6186C20.2836 29.872 20.7465 30.0061 21.2188 30.005C21.2901 30.005 21.3626 30.005 21.4351 29.9963C21.9404 29.956 22.4211 29.7617 22.8125 29.4396C23.2039 29.1175 23.4871 28.6831 23.6238 28.195L30.8963 4.20625C30.9 4.19734 30.9029 4.18814 30.9051 4.17875C31.0256 3.75103 31.03 3.2989 30.9177 2.86893C30.8055 2.43896 30.5806 2.04668 30.2663 1.7325ZM21.1238 26.115L16.9088 17.2163L22.5651 11.56C22.8469 11.2782 23.0052 10.896 23.0052 10.4975C23.0052 10.099 22.8469 9.7168 22.5651 9.435C22.2833 9.15321 21.9011 8.9949 21.5026 8.9949C21.1041 8.9949 20.7219 9.15321 20.4401 9.435L14.7838 15.0913L5.88382 10.875L27.7488 4.25L21.1238 26.115Z",
			fill: "#212121"
		})
	})
});
export default SvgNavShare;
